import { EditOrgComponent } from './edit-org.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { updateOrgs, updateLocations } from '../dashboard.actions';

export const EditOrg = connect(
  (state: AppState) => ({ sState: state }),
  { updateOrgs, updateLocations }
)(EditOrgComponent as any) as unknown as typeof EditOrgComponent;
